import { render, staticRenderFns } from "./lend-record.vue?vue&type=template&id=5cd6e7e0&scoped=true"
import script from "./lend-record.vue?vue&type=script&lang=js"
export * from "./lend-record.vue?vue&type=script&lang=js"
import style0 from "./lend-record.vue?vue&type=style&index=0&id=5cd6e7e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6e7e0",
  null
  
)

export default component.exports